export const getScorecard = async () => {
    const response = await fetch('workstream/1/scorecard');
    return await response.json();
};

export default {
    getScorecard,
};
